module.exports = __webpack_public_path__ + "static/media/sprint.968b443a.svg";